import _this from '../main';
import axios from 'axios';
import qs from 'qs';

const { interceptors } = axios;

axios.defaults.baseURL = process.env.VUE_APP_API_DOMAIN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// axios.defaults.withCredentials = true;

interceptors.request.use(async (config) => {
  // (BenLi) GET 传数组 兼容服务端
  if (config.url.indexOf('income-targets') >=0) {
    config.paramsSerializer= (innerParams) => {
      return qs.stringify(innerParams, { arrayFormat: 'repeat' });
    } ;
  }

  if (_this.globalData.token && !config.headers['grpc-metadata-token']) {
    config.headers.common['grpc-metadata-token'] = _this.globalData.token;
  }
  // const { method, data } = config;
  // if (method === 'post') {
  //   config.data = JSON.stringify(data);
  // }
  return config;
});

export default axios;
